import React, { FC } from 'react';
import { Card, Image } from 'antd';
import { CertificateEmptyIcon } from 'components/icons';
import { useImageBlobSrc } from 'hooks';
import { EpCertificate } from 'types/graphql-types';
import { isPDF } from 'utils';
import styles from './styles.less';

export const Certificate: FC<EpCertificate> = ({ certificate, image }) => {
  const imageSource = image || '';
  const isPDFFile = isPDF(imageSource);
  const { src } = useImageBlobSrc(imageSource);

  const imageComponent = (
    <>
      {isPDFFile || !src ? (
        <div className={styles.certificate}>
          <CertificateEmptyIcon />
        </div>
      ) : (
        <Image
          className={styles.certificate}
          src={src}
          alt={certificate || 'Certificate'}
          preview={false}
        />
      )}
    </>
  );

  return (
    <Card className={styles.card} bordered={false} cover={imageComponent}>
      {certificate || 'Certificate'}
    </Card>
  );
};
